module.exports = __webpack_public_path__ + "assets/google_icon1.8befec72.svg";